const cartEl = document.querySelector("header > .cart")
const cartModalEl = document.querySelector(".cart-modal")

cartEl.addEventListener("click", () => {
    const isCartModalHidden = cartModalEl.dataset.hidden;

    if (isCartModalHidden === "true") {
        cartModalEl.dataset.hidden = false;
    } else {
        cartModalEl.dataset.hidden = true;
    }

})

const openSidenavBtnEl = document.querySelector(".menu")
const closeSidenavBtnEl = document.querySelector(".sidenav > .close-btn")
const sidenavEl = document.querySelector(".sidenav-container")

openSidenavBtnEl.addEventListener("click", () => {
    document.body.style.overflow = "hidden"
    sidenavEl.dataset.hidden = false;
})

closeSidenavBtnEl.addEventListener("click", () => {
    document.body.style.overflow = ""
    sidenavEl.dataset.hidden = true;
})

sidenavEl.addEventListener("click", e => {
    if (e.target !== sidenavEl) return;
    sidenavEl.dataset.hidden = true;
})

const mainImageWrapperEl = document.querySelector(".gallery > .main-img-wrapper")
const lightboxWrapperEl = document.querySelector(".lightbox-gallery-wrapper")

mainImageWrapperEl.addEventListener("click", () => {
    if (window.matchMedia("(min-width: 1024px").matches)
        lightboxWrapperEl.dataset.hidden = "false";
})
